<template>
  <generic-modal
    size="large"
    :title="$t('payment')"
    icon="payment"
    image="/images/icons/payment_type.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :footer_buttons="footer_buttons"
    :show_ok="show_ok"
    :show_cancel="show_cancel"
    ref="modal"
  >
    <div class="description">
      <div class="ui shape" ref="shape">
        <div class="sides">
          <div class="active side">
            <div class="ui form">
              <div class="ui two cards">
                <div
                  class="card"
                  v-for="(method, index) in payment_methods"
                  :key="index"
                >
                  <div class="content">
                    <div class="ui form">
                      <div class="two fields">
                        <div class="field">
                          <label for>{{ method.name }}</label>
                          <div class="ui left icon input">
                            <i class="money icon"></i>
                            <input
                              type="text"
                              :placeholder="$t('amount')"
                              v-model="payment_methods[index].amount"
                            />
                          </div>
                        </div>
                        <div class="field" v-if="method.ask_for_document">
                          <label for>{{ $t("document number") }}</label>
                          <div class="ui left icon input">
                            <i class="receipt icon"></i>
                            <input
                              type="text"
                              :placeholder="$t('document number')"
                              v-model="payment_methods[index].document_number"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ui basic segment">
                <div class="ui two column grid">
                  <div class="column">
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="show_receipt"
                        v-model="show_receipt"
                      />
                      <label>{{ $t("show receipt on finish") }}</label>
                    </div>
                  </div>
                  <div class="column" v-if="billing_template">
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="show_receipt"
                        v-model="emit_bill"
                      />
                      <label>
                        {{ $t("emit billing") }}
                        <small>| {{ billing_template.name }}</small>
                      </label>
                    </div>
                    <div
                      class="ui form"
                      v-if="emit_bill"
                      style="margin-top: 10px"
                    >
                      <div class="two fields">
                        <div class="field">
                          <label for>{{ $t("nit") }}</label>
                          <div class="ui left icon input">
                            <i class="id card icon"></i>
                            <input
                              type="text"
                              :placeholder="$t('nit')"
                              v-model="billing_info.nit"
                            />
                          </div>
                        </div>
                        <div class="field">
                          <label for>{{ $t("name") }}</label>
                          <div class="ui left icon input">
                            <i class="id card icon"></i>
                            <input
                              type="text"
                              :placeholder="$t('name')"
                              v-model="billing_info.name"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="two fields">
                        <div class="field">
                          <label for>{{ $t("address") }}</label>
                          <div class="ui left icon input">
                            <i class="home icon"></i>
                            <input
                              type="text"
                              :placeholder="$t('name')"
                              v-model="billing_info.address"
                            />
                          </div>
                        </div>
                        <div class="field">
                          <label for>{{ $t("email") }}</label>
                          <div class="ui left icon input">
                            <i class="at icon"></i>
                            <input
                              type="text"
                              :placeholder="$t('name')"
                              v-model="billing_info.email"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ui error message"></div>
            </div>
            <!-- <pre>{{ payment_methods }}</pre> -->
            <div
              class="ui right floated orange small statistic"
              style="margin-top: 20px"
            >
              <div class="label">{{ $t("total") }}</div>
              <div class="value">
                {{ total | formatCurrency(enterprise_setup.currency_iso) }}
              </div>
            </div>
            <div
              class="ui right floated red small statistic"
              ref="pending_statistic"
              style="margin-top: 20px"
              v-if="pending >= 0"
            >
              <div class="label">{{ $t("pending") }}</div>
              <div class="value">
                {{ pending | formatCurrency(enterprise_setup.currency_iso) }}
              </div>
            </div>
            <div
              class="ui right floated green small statistic"
              ref="change_statistic"
              style="margin-top: 20px"
              v-if="pending < 0"
            >
              <div class="label">{{ $t("change") }}</div>
              <div class="value">
                {{
                  Math.abs(pending)
                    | formatCurrency(enterprise_setup.currency_iso)
                }}
              </div>
            </div>
          </div>
          <div class="side">
            <receipt
              id="receipt_print"
              :payment_in="payment"
              :customer_in="customer"
              :total_in="total"
              :cart_in="cart"
              :session_in="session"
              :template_in="receipt_template.template"
            />
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
// import _ from "lodash";
import GenericModal from "@/components/GenericModal";
import Receipt from "./PaymentModalReceipt";
import PHE from "print-html-element";

export default {
  name: "PaymentModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    Receipt,
  },
  props: { total: Number, customer: Object, cart: Array, session: Object },
  data() {
    return {
      payment_methods: [],
      show_receipt: false,
      emit_bill: false,
      receipt_template: {},
      payment: { sale: {} },
      footer_buttons: [],
      billing_template: {},
      billing_info: {
        name: "",
        nit: "",
        address: "",
        email: "",
      },
      payment_ok: false,
    };
  },
  computed: {
    pending() {
      let payed = this.payment_methods.reduce(function (prev, current) {
        return prev + Number(current.amount || 0);
      }, 0);
      return this.total - payed;
    },
    show_ok() {
      if (!this.payment.sale.uuid) return true;
      else {
        if (this.show_receipt) return false;
        return true;
      }
    },
    show_cancel() {
      return !this.payment.sale.uuid;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else if (vm.pending > 0) {
          // window
          //   .jQuery(vm.$refs.form)
          //   .form("add errors", [vm.$t("payment incomplete")]);
          window.jQuery(vm.$refs.pending_statistic).transition("tada");
          reject();
        } else {
          let _setup = {
            p: vm.cart,
            c: vm.customer ? vm.customer.customer_id : undefined,
            y: vm.payment_methods,
            t: vm.total,
            s: vm.session ? vm.session.session_id : null,
            b: {
              emit: vm.emit_bill,
              info: vm.billing_info,
              template: vm.billing_template ? vm.billing_template.id : "",
            },
          };
          local_api(vm, "post", "/point_of_sale/do-pay", {
            s: _setup,
          })
            .then((r) => {
              vm.payment_ok = true;
              if (vm.show_receipt) {
                vm.payment = r;
                window.jQuery(vm.$refs.shape).shape("flip back");
                vm.footer_buttons.push({
                  text: vm.$t("close"),
                  icon: "sign out alternate",
                  click: function () {
                    vm.$emit("payment_success", r);
                    resolve();
                  },
                  color: "blue",
                });
                vm.footer_buttons.push({
                  text: vm.$t("print"),
                  icon: "print",
                  click: function () {
                    PHE.printElement(document.getElementById("receipt_print"));
                  },
                  color: "orange",
                });
                vm.$refs.modal.set_loading(false);
              } else {
                vm.$emit("payment_success", r);
                resolve();
              }
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      if (this.payment_ok) this.$emit("payment_success", {});
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: { name: ["empty"] },
    });

    local_api(this, "post", "/point_of_sale/do-get-configuration")
      .then((r) => {
        let conf = r.conf_pos;
        if (conf && conf.setup && conf.setup.payment_methods) {
          vm.payment_methods = conf.setup.payment_methods.map((m) => {
            m.amount = "";
            m.document_number = "";
            return m;
          });
        }

        if (conf && conf.setup && conf.setup.receipt_templates) {
          vm.receipt_template = conf.setup.receipt_templates.find(
            (t) => t.set_as_default,
          );
        }

        if (conf && conf.setup && conf.setup.billing_templates) {
          vm.billing_template = conf.setup.billing_templates.find(
            (t) => t.set_as_default,
          );
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {
    emit_bill() {
      if (this.emit_bill) this.show_receipt = true;
    },
    show_receipt() {
      if (!this.show_receipt) this.emit_bill = false;
    },
  },
  updated: function () {},
};
</script>

<style>
.ui.shape {
  width: 100% !important;
}
</style>
